import React from 'react';
import { TargetCriteriaCard } from './targetCriteriaCard';

/** Per-target BASELINE -> TEACHING criteria, with an override that can follow the goal-level criteria. */
export const BaselineTeaching = ({ target }) => <TargetCriteriaCard kind="baseline" target={target} />;
